import React from "react";

const ProfileIcon = () => (
  <svg
    className="icon--profile"
    xmlns="http://www.w3.org/2000/svg"
    width="77.125"
    height="77.806"
    viewBox="0 0 77.125 77.806"
  >
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="4"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M71.253 19.245l-2.362-1.1-.01.01c-.018-.02-.05-.04-.08-.05-1.21-.5-2.43-.972-3.65-1.412-1.1-.39-2.2-.75-3.31-1.09-.13-.04-.252-.09-.382-.12-13.746-4.18-28.193-4.53-42.05-1.03-.24.06-.47.13-.71.19-1 .26-2.012.53-3.012.84-.87.26-1.742.57-2.612.86-.36.13-.73.23-1.08.362-1.23.44-2.462.91-3.672 1.42-.03.01-.05.03-.08.04v-.01l-2.37 1.11L2 9.93l2.482-1.1c21.99-9.104 46.19-9.104 68.162-.01l2.48 1.1-3.87 9.325zM22.423 42.755L10.518 18.38M46.656 59.233l-8.09 16.573L30.47 59.23M66.605 18.372L54.7 42.758"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="4"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M54.698 42.757c-2.4-3.446-5.833-5.612-9.628-5.612h-2.307c2.684-1.575 4.502-4.61 4.502-8.094 0-5.103-3.892-9.243-8.703-9.243-4.81 0-8.7 4.14-8.7 9.244 0 3.486 1.817 6.52 4.5 8.095h-2.31c-7.21 0-13.11 7.82-13.11 17.378v4.712h11.53"
    />
    <path
      fill="none"
      stroke="#fff"
      strokeWidth="4"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M46.656 59.233h11.527v-4.71c0-4.528-1.324-8.666-3.485-11.768M30.472 59.233h16.183"
    />
  </svg>
);

export default ProfileIcon;
